import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchAdminUsers, createAdminUser, updateUserRole, deleteAdminUser } from "../services/api";
import { AdminUser, AdminUserRole, CreateAdminUserRequest, AdminUserListResponse } from "../types";

/**
 * 管理者ユーザー一覧を取得
 */
export const useAdminUsers = () => {
  return useQuery<AdminUserListResponse, Error>("adminUsers", fetchAdminUsers, {
    staleTime: 10 * 60 * 1000, // 10分
  });
};

/**
 * 管理者ユーザーを作成
 */
export const useCreateAdminUser = () => {
  const queryClient = useQueryClient();

  return useMutation<{ success: boolean; user: AdminUser }, Error, CreateAdminUserRequest>(
    (data) => createAdminUser(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("adminUsers");
      },
    }
  );
};

/**
 * ユーザーロールを更新
 */
export const useUpdateUserRole = () => {
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean; uid: string; newRole: AdminUserRole },
    Error,
    { uid: string; role: AdminUserRole }
  >(({ uid, role }) => updateUserRole(uid, role), {
    onSuccess: () => {
      queryClient.invalidateQueries("adminUsers");
    },
  });
};

/**
 * 管理者ユーザーを削除
 */
export const useDeleteAdminUser = () => {
  const queryClient = useQueryClient();

  return useMutation<{ success: boolean; uid: string }, Error, string>(
    (uid) => deleteAdminUser(uid),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("adminUsers");
      },
    }
  );
};
